export default function PricingSection() {
  return (
    <section id="certificados" className="relative py-20 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            Certificados
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 font-heading">
            Escolha o certificado ideal para você ou sua empresa
          </h2>
        </div>

        <div id="emitir" className="mt-12 grid md:grid-cols-2 gap-6">
          {/* e-CPF Card */}
          <div className="relative rounded-3xl p-8 flex flex-col bg-background-50 text-foreground-800 border border-secondary-200 hover:border-accent-400 hover:shadow-lg hover:shadow-accent-500/5 transition-all">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl flex items-center justify-center bg-accent-100 text-accent-600">
                <i className="ri-user-line text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-accent-600 font-medium">Pessoa física</div>
                <div className="font-heading text-2xl font-semibold text-foreground-950">e-CPF A1</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-foreground-600">
              Ideal para pessoa física, sócios, responsáveis legais, profissionais liberais e quem precisa assinar documentos ou acessar sistemas do governo.
            </p>
            <ul className="mt-6 space-y-2.5">
              {[
                "Assinatura digital",
                "Acesso a sistemas públicos",
                "Procurações eletrônicas",
                "Declarações e obrigações pessoais",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-check-line text-accent-500 mt-0.5"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-500"></i>
              Emitido por meio da Soluti, AC de 1º nível na ICP-Brasil.
            </div>
            <div className="mt-auto flex items-end justify-between gap-4 pt-6 border-t border-secondary-200/70">
              <div>
                <div className="text-xs text-foreground-500">A partir de</div>
                <div className="font-heading text-3xl font-bold text-primary-500">R$ 148,00</div>
              </div>
              <a
                href="https://wa.me/5547991891311"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition-all bg-primary-500 text-background-50 hover:bg-primary-600 whitespace-nowrap"
              >
                Emitir meu e-CPF
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </a>
            </div>
          </div>

          {/* e-CNPJ Card */}
          <div className="relative rounded-3xl p-8 flex flex-col bg-primary-500 text-background-50 border-2 border-accent-400">
            <span className="absolute -top-3 right-6 rounded-full bg-accent-500 text-background-50 text-xs font-semibold px-3 py-1 shadow-sm">
              Mais escolhido
            </span>
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl flex items-center justify-center bg-accent-500 text-background-50">
                <i className="ri-building-2-line text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-accent-400 font-medium">Empresas & MEI</div>
                <div className="font-heading text-2xl font-semibold">e-CNPJ A1</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-background-50/75">
              Ideal para empresas, MEIs e negócios que precisam emitir notas fiscais, acessar obrigações fiscais e assinar documentos digitais.
            </p>
            <ul className="mt-6 space-y-2.5">
              {[
                "Emissão de NF-e",
                "Emissão de NFC-e",
                "Acesso ao e-CAC",
                "Obrigações contábeis e fiscais",
                "Assinatura de documentos empresariais",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-background-50/80">
                  <i className="ri-check-line text-accent-400 mt-0.5"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-50/60">
              <i className="ri-shield-check-line text-accent-400"></i>
              Emitido por meio da Soluti, AC de 1º nível na ICP-Brasil.
            </div>
            <div className="mt-auto flex items-end justify-between gap-4 pt-6 border-t border-background-50/15">
              <div>
                <div className="text-xs text-background-50/60">A partir de</div>
                <div className="font-heading text-3xl font-bold text-accent-400">R$ 195,00</div>
              </div>
              <a
                href="https://wa.me/5547991891311"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition-all bg-accent-500 text-primary-950 hover:bg-background-50 whitespace-nowrap"
              >
                Emitir meu e-CNPJ
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}